import {createSelector} from 'reselect';
import {isClickAndCollectButtonLayout} from './clickAndCollectButtonSelectors';
import {getSettings} from './selectors';

export default createSelector(
  [isClickAndCollectButtonLayout, getSettings],
  (clickAndCollectButtonLayout, settings) => settings.use_address_type_buttons || clickAndCollectButtonLayout,
);
